export const getIframeTargetOrigin = (src?: string | null): string => {
  if (!src) {
    return '*';
  }

  try {
    return new URL(src).origin;
  } catch {
    return '*';
  }
};
